import { motion, type TargetAndTransition } from "framer-motion";
import type { IcpHistoryItem } from "../hooks/useTodos";
import { listRow } from "../motion";

// Completed ICP row in the To-dos Done view. A past cycle is a recorded fact,
// not a check-off to-do — so there is no checkbox and no delete; the row shows
// the resident + the staff-written ICP date (the anchor for the next cycle).

export function IcpHistoryRow({ item, homeName }: { item: IcpHistoryItem; homeName?: string }) {
  return (
    <motion.li className="todo-row-item" variants={listRow} exit={listRow.exit as TargetAndTransition}>
      <div className="todo-row">
        <div className="todo-main">
          <p className="todo-title">
            {item.name} {item.bed ? <span className="muted">· {item.bed}</span> : null}
          </p>
          <div className="todo-meta">
            {homeName ? <span className="chip">{homeName}</span> : null}
            <span className="chip chip-ok">ICP completed</span>
            <span className="chip">{item.icpDate}</span>
          </div>
        </div>
      </div>
    </motion.li>
  );
}
